import { createSlice } from '@reduxjs/toolkit';
import { getLanguageFromStorage, getDirectionFromLanguage } from '../../utils/languageUtils';

interface StateType {
  activeDir?: string;
  isLanguage?: string;
}

const currentLang = getLanguageFromStorage();
const currentDir = getDirectionFromLanguage(currentLang);

const initialState: StateType = {
  activeDir: currentDir,
  isLanguage: currentLang,
};

export const CustomizerSlice = createSlice({
  name: 'customizer',
  initialState,
  reducers: {
    setDir: (state, action) => {
      state.activeDir = action.payload;
    },
    setLanguage: (state, action) => {
      state.isLanguage = action.payload;
      state.activeDir = getDirectionFromLanguage(action.payload);
    },
  },
});

export const {
  setDir,
  setLanguage,
} = CustomizerSlice.actions;
export default CustomizerSlice.reducer;
